/* jupyter stories: lazy films, reveals, scroll-linked scale, and the Helios click-through. */
(function(){
  var reduce = window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches;
  var yr = document.getElementById("yr"); if (yr) yr.textContent = new Date().getFullYear();

  /* films load when near the screen and pause when they leave it */
  var films = document.querySelectorAll("video[data-film]");
  var fo = new IntersectionObserver(function(es){
    es.forEach(function(e){
      var v = e.target, s = v.querySelector("source[data-src]");
      if (e.isIntersecting){
        if (s && !s.src){ s.src = s.getAttribute("data-src"); v.load(); }
        if (!reduce) v.play().catch(function(){});
      } else if (!v.paused) v.pause();
    });
  }, {rootMargin:"200px 0px", threshold:.01});
  films.forEach(function(v){ fo.observe(v); });

  /* reveals */
  var ro = new IntersectionObserver(function(es,o){
    es.forEach(function(e){ if (e.isIntersecting){ e.target.classList.add("in"); o.unobserve(e.target); } });
  }, {threshold:.18});
  document.querySelectorAll(".fx").forEach(function(el){ ro.observe(el); });

  /* scroll-linked progress (--p 0..1) for the hero zoom and growing films */
  var grows = [].slice.call(document.querySelectorAll("[data-grow],.st-hero"));
  function tick(){
    var h = innerHeight;
    grows.forEach(function(el){
      var r = el.getBoundingClientRect(), p;
      if (el.classList.contains("st-hero")) p = Math.min(1, Math.max(0, -r.top / h));
      else p = Math.min(1, Math.max(0, (h - r.top) / (h * .9)));
      el.style.setProperty("--p", p.toFixed(3));
    });
  }
  if (!reduce){ addEventListener("scroll", function(){ requestAnimationFrame(tick); }, {passive:true}); addEventListener("resize", tick); tick(); }
  else grows.forEach(function(el){ el.style.setProperty("--p", 1); });

  /* ---------------- Helios click-through ---------------- */
  var ct = document.getElementById("ct"); if (!ct) return;
  var win = ct.querySelector(".ct-win"), cur = ct.querySelector(".ct-cur"), rip = ct.querySelector(".ct-rip");
  var cap = ct.querySelector(".ct-capbar span"), dots = ct.querySelectorAll(".ct-dots i");
  var q = ct.querySelector("[data-q]"), timers = [], running = false;
  function $(s){ return ct.querySelector(s); }
  function wait(ms){ return new Promise(function(r){ timers.push(setTimeout(r, ms)); }); }
  function at(sel){
    var el = $(sel); if (!el) return {x:0,y:0};
    var a = el.getBoundingClientRect(), b = ct.getBoundingClientRect();
    return {x:a.left - b.left + a.width*.5, y:a.top - b.top + a.height*.55};
  }
  function move(sel){ var p = at(sel); cur.style.transform = "translate(" + p.x + "px," + p.y + "px)"; return wait(1050); }
  function click(sel){
    var p = at(sel); rip.style.left = p.x + "px"; rip.style.top = p.y + "px";
    rip.classList.remove("go"); void rip.offsetWidth; rip.classList.add("go");
    var el = $(sel); if (el){ el.classList.add("press"); setTimeout(function(){ el.classList.remove("press"); }, 220); }
    return wait(380);
  }
  function panel(name, step, text){
    ct.querySelectorAll(".ct-p").forEach(function(p){ p.classList.toggle("on", p.dataset.p === name); });
    ct.querySelectorAll(".ct-tab").forEach(function(t){ t.classList.toggle("on", t.dataset.t === name); });
    dots.forEach(function(d,i){ d.classList.toggle("on", i === step); });
    cap.style.opacity = 0; setTimeout(function(){ cap.textContent = text; cap.style.opacity = 1; }, 300);
  }
  function reset(){
    q.textContent = "";
    ct.querySelectorAll(".ct-r").forEach(function(r){ r.classList.remove("in"); });
    ct.querySelectorAll(".ct-k").forEach(function(k){ k.classList.remove("hit"); });
    ct.querySelectorAll(".ct-f").forEach(function(f){ f.classList.remove("pop"); });
    var bx = $(".ct-box"); bx.style.width = "0"; bx.style.height = "0";
    $(".ct-crop").classList.remove("in"); $(".ct-ok").classList.remove("in"); $(".ct-toast").classList.remove("in");
  }
  async function typeIn(text){ for (var i = 0; i < text.length; i++){ q.textContent += text[i]; await wait(55 + Math.random()*45); } }
  async function play(){
    if (running) return; running = true;
    while (running){
      reset();
      panel("brief", 0, "7:30 every morning, the Morning Brief reads yesterday back to you.");
      await wait(900); await move("[data-k=courier]"); await click("[data-k=courier]");
      $("[data-k=courier]").classList.add("hit"); await wait(1500);
      await move("[data-t=people]"); await click("[data-t=people]");
      panel("people", 1, "People, not detections. Every face becomes one person, across days.");
      await wait(700);
      var fs = ct.querySelectorAll(".ct-f");
      for (var i = 0; i < fs.length; i++){ fs[i].classList.add("pop"); await wait(140); fs[i].classList.remove("pop"); }
      await move(".ct-f[data-new]"); await click(".ct-f[data-new]"); $(".ct-f[data-new]").classList.add("pop"); await wait(1500);
      await move("[data-t=search]"); await click("[data-t=search]");
      panel("search", 2, "Visual search. Type what you remember, jump straight to the moment.");
      await move(".ct-q"); await click(".ct-q"); await typeIn("courier with a parcel");
      await wait(350);
      var rs = ct.querySelectorAll(".ct-r");
      for (var j = 0; j < rs.length; j++){ rs[j].classList.add("in"); await wait(160); }
      await wait(1100); await move(".ct-r"); await click(".ct-r"); await wait(900);
      await move("[data-t=watch]"); await click("[data-t=watch]");
      panel("watch", 3, "Draw one box. The hub watches for that face from now on.");
      await move(".ct-box"); await wait(200);
      var bx = $(".ct-box"); bx.style.width = "26%"; bx.style.height = "40%";
      var p0 = at(".ct-box"); cur.style.transform = "translate(" + (p0.x + win.clientWidth*.14) + "px," + (p0.y + win.clientHeight*.2) + "px)";
      await wait(1100); $(".ct-crop").classList.add("in"); await wait(700);
      await move("[data-add]"); await click("[data-add]"); $(".ct-ok").classList.add("in"); await wait(1300);
      panel("watch", 4, "When they come back, you hear about it first, and the Halo can speak up.");
      $(".ct-toast").classList.add("in"); await wait(3600);
      await move("[data-t=brief]"); await click("[data-t=brief]");
    }
  }
  function stop(){ running = false; timers.forEach(clearTimeout); timers = []; }
  if (reduce){ panel("people", 1, "People, not detections. Every face becomes one person, across days."); return; }
  new IntersectionObserver(function(es){ es.forEach(function(e){ if (e.isIntersecting) play(); else stop(); }); }, {threshold:.35}).observe(ct);
})();
